import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { formatDateTime } from '@/helpers/formatting';
import { getImportStateMeta, ImportState } from '@/helpers/import';
import type { CollectionImportListItemDTO } from '@/api/trafikportalen';
import Button from '../core/Button';

interface CollectionImportListItemProps {
  importItem: CollectionImportListItemDTO;
  creatorName?: string;
  onClick?: () => void;
}

export const CollectionImportListItem = ({
  importItem,
  creatorName,
  onClick,
}: CollectionImportListItemProps) => {
  const summaryEntries = useMemo(() => {
    return Object.entries(importItem.summary).filter(
      ([, count]) => (count as number) > 0,
    );
  }, [importItem.summary]);

  return (
    <Button
      className="w-full flex-col items-start py-2 font-normal"
      onClick={onClick}
    >
      <div className="flex w-full flex-wrap justify-between">
        <span className="font-medium text-text-950">
          {formatDateTime(importItem.created_at)}
        </span>
        <span className="text-text-800">
          {creatorName ?? (
            <i>
              <FormattedMessage defaultMessage="Okänd skapare (behörighet saknas eller borttagen)" />
            </i>
          )}
        </span>
      </div>
      <div className="flex flex-wrap gap-x-5 gap-y-2">
        {summaryEntries.map(([status, count]) => {
          const { icon: Icon, textColor } = getImportStateMeta(
            status as ImportState,
          );
          return (
            <div
              key={status}
              className="flex items-center gap-1 text-base text-text-700"
            >
              <Icon className={`size-4 ${textColor}`} />
              <span>
                {count as number}{' '}
                <FormattedMessage
                  id={`import.state.${status}${(count as number) === 1 ? '' : 'Plural'}`}
                />
              </span>
            </div>
          );
        })}
      </div>
    </Button>
  );
};
